export default {
  all: {},
  one: {},
  newArticle: {},
};
